/** Tracks whether live price came from NATS (must not be overwritten by stale API). */
export const PRICE_SOURCE = "priceSource";

export const stripLivePriceFields = <T extends Record<string, any>>(stock: T): T => {
  const copy = { ...stock } as T;
  delete copy.price;
  delete copy.changesPercentage;
  delete copy.change;
  delete copy.pct_change;
  delete (copy as any).changes_percentage;
  return copy;
};

/** Merge getStockData / API row — never clobber NATS live price. */
export const mergeApiStockRow = (
  existing: Record<string, any> | undefined,
  incoming: Record<string, any>
): Record<string, any> => {
  if (!incoming?.stockId) return existing ?? incoming;

  if (existing?.[PRICE_SOURCE] === "nats") {
    return {
      ...existing,
      ...stripLivePriceFields(incoming),
      [PRICE_SOURCE]: "nats",
    };
  }

  if (incoming?.[PRICE_SOURCE] === "nats") {
    return { ...existing, ...incoming };
  }

  return existing ? { ...existing, ...incoming } : { ...incoming };
};

export const withNatsPrice = (
  row: Record<string, any>,
  price: number,
  changesPercentage?: number | string | null
): Record<string, any> => {
  const next: Record<string, any> = { ...row, price, [PRICE_SOURCE]: "nats" };
  if (changesPercentage != null && changesPercentage !== "0") {
    next.changesPercentage = changesPercentage;
  }
  return next;
};
